import { LinkButton, Typography } from 'components/Contentful'
import Bars from 'components/Svgs/Bars'
import { Phone } from 'react-feather'
import { Button } from '@achieve/ascend'
import FinancialBarChart from 'components/FinancialBarChart/FinancialBarChart'
import { AchieveLink } from '@/components/AchieveLink'

function BarGraphContent({
  helocUpdated,
  chartData,
  jsonConfig,
  licensedFlag,
  button,
  phone,
  unlicensedButton,
  disclaimer,
  negativeEquityConfig,
}) {
  return (
    <>
      <div className="sm:flex text-left flex-row flex-nowrap">
        {!helocUpdated && (
          <>
            <Bars width={48} height={48} />
            <Typography
              variant="displaySm"
              className="my-auto"
              content={jsonConfig?.mainTitle || 'Approximate monthly payment by term'}
            />
          </>
        )}
      </div>
      <div className="flex flex-col scale-75 sm:scale-100 items-center sm:hidden block justify-center">
        <FinancialBarChart data={chartData} updated={helocUpdated} thinPadding={true} />
      </div>
      <div className="flex flex-col sm:scale-100 items-center m-auto sm:block hidden justify-center">
        <FinancialBarChart data={chartData} updated={helocUpdated} />
      </div>
      <div className="flex flex-col items-center">
        {licensedFlag ? (
          <>
            {button &&
              (helocUpdated ? (
                <div className="sm:py-4 sm:w-1/2 w-[95%] -pt-2">
                  <LinkButton
                    track={{
                      event_type: 'heloc_calc_see_if_you_qualify',
                      ...button.event,
                    }}
                    variant="contained"
                    color="primary"
                    content={button}
                    className={'w-full sm:block hidden'}
                    typographicOptions={{ variant: 'bodyLg', fontWeight: 'bold' }}
                    underline="hover"
                  />
                  <LinkButton
                    track={{
                      event_type: 'heloc_calc_see_if_you_qualify',
                      ...button.event,
                    }}
                    variant="contained"
                    color="primary"
                    content={{ ...button, linkText: 'Get my rate' }}
                    className={'w-full block sm:hidden'}
                    typographicOptions={{ variant: 'bodyLg', fontWeight: 'bold' }}
                    underline="hover"
                  />
                </div>
              ) : (
                <div className="py-4 w-full">
                  <LinkButton
                    track={{
                      event_type: 'heloc_calc_see_if_you_qualify',
                      ...button.event,
                    }}
                    variant="contained"
                    color="primary"
                    content={button}
                    className={'w-full'}
                    typographicOptions={{ variant: 'bodyLg', fontWeight: 'bold' }}
                    underline="hover"
                  />
                </div>
              ))}

            {phone &&
              (helocUpdated ? (
                <div className="py-4 sm:w-1/2 w-[95%] text-center">
                  <AchieveLink
                    track={{
                      event_type: 'heloc_calc_contact_a_loan_specialist',
                      ...phone.event,
                    }}
                    href={
                      negativeEquityConfig?.buttons?.call?.phone
                        ? `tel:${negativeEquityConfig?.buttons?.call?.phone}`
                        : null
                    }
                  >
                    <>
                      <div className="flex flex-col align-center items-center justify-center hidden sm:block">
                        <Typography
                          variant="displayXs"
                          fontWeight="bold"
                          content={negativeEquityConfig?.buttons?.call?.phone}
                        />
                      </div>
                      <div className="flex flex-col lg:flex-row w-full sm:hidden block text-center">
                        <Button
                          className={'sm:mt-4 w-full bg-[#D2E2FE] text-[#154199]'}
                          type="button"
                          color="primary"
                          variant="contained"
                          content={{
                            linkHref: negativeEquityConfig?.buttons?.call?.phone,
                          }}
                        >
                          {'Call Us'}
                        </Button>
                      </div>
                    </>
                  </AchieveLink>
                </div>
              ) : (
                <div className="py-4 w-full">
                  <LinkButton
                    track={{
                      event_type: 'heloc_calc_contact_a_loan_specialist',
                      ...phone.event,
                    }}
                    variant="contained"
                    color="secondary"
                    content={phone}
                    className={'w-full'}
                    typographicOptions={{ variant: 'bodyLg', fontWeight: 'bold' }}
                    underline="hover"
                    startIcon={<Phone data-testid="circle-icon" />}
                  />
                </div>
              ))}
          </>
        ) : (
          <>
            {unlicensedButton && !helocUpdated && (
              <div className="py-4">
                <LinkButton
                  track={{
                    ...unlicensedButton.event,
                  }}
                  variant="text"
                  color="primary"
                  content={unlicensedButton}
                  className="w-full "
                  typographicOptions={{ variant: 'bodyLg', fontWeight: 'bold' }}
                  underline="hover"
                />
              </div>
            )}
          </>
        )}
        {disclaimer && (
          <Typography
            content={disclaimer?.textContent}
            variant="bodyXs"
            fontWeight="regular"
            className="py-4 sm:py-6 sm:px-16 text-[#5C708A]"
          />
        )}
      </div>
    </>
  )
}

export { BarGraphContent }
